import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TsFilterComponent } from './ts-filter.component';
import { TsButtonModule } from '../ts-button';
import { MatIconModule } from '@angular/material/icon';
import { TsFilterListModule } from '../ts-filter-list';
import { TsInputComponent } from '../ts-input';

@NgModule({
  declarations: [TsFilterComponent],
  imports: [CommonModule, ReactiveFormsModule, TsButtonModule, TsFilterListModule, MatIconModule, TsInputComponent],
  exports: [TsFilterComponent],
})
export class TsFilterModule {}
